import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Transaction } from "../types/transactions";
import { BASE_URL, envConfig } from "../config";

// Define a service using a base URL and expected endpoints
export const transactionsApi = createApi({
  reducerPath: "transactionsApi",
  baseQuery: fetchBaseQuery({
    credentials: "include",
    baseUrl: BASE_URL + "transactions",
    prepareHeaders: (headers) => {
      headers.set("api-key", `${envConfig.API_KEY}`);
      return headers;
    },
  }),
  tagTypes: ["Transactions"],
  endpoints: (builder) => ({
    getTransactions: builder.query<Transaction[], string>({
      query: () => `/`,
      providesTags: ["Transactions"],
    }),
    updateTransactions: builder.mutation<Transaction, Transaction>({
      query: ({ _id, ...patch }) => ({
        url: `/${_id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: ["Transactions"],
    }),
    deleteTransactions: builder.mutation<
      { success: boolean; _id: string },
      string
    >({
      query: (_id) => ({
        url: `/${_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Transactions"],
    }),
    createTransactions: builder.mutation<Transaction, Transaction>({
      query: ({ _id, ...transaction }) => ({
        url: `/`,
        method: "POST",
        body: transaction,
      }),
      invalidatesTags: ["Transactions"],
    }),
    getTransactionsCalculation: builder.mutation<any, any>({
      query: ({ _id, ...filter }) => ({
        url: `/calculations`,
        method: "POST",
        body: filter,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTransactionsQuery,
  useCreateTransactionsMutation,
  useUpdateTransactionsMutation,
  useDeleteTransactionsMutation,
  useGetTransactionsCalculationMutation,
} = transactionsApi;
